import React from 'react';

import { LoadingAnimation } from '../../../LoadingAnimation';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuContentLoading = () => {
  return <LoadingAnimation />;
};
